// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CoreXNav-cls1__e92be74cf203c519cc7d{/*!*/}.CoreXNav-cls2___9e3dc5b1980fa709e9b{height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CoreXNav-cls1__e92be74cf203c519cc7d",
	"cls2": "CoreXNav-cls2___9e3dc5b1980fa709e9b CoreXNav-cls1__e92be74cf203c519cc7d"
};
export default ___CSS_LOADER_EXPORT___;
